import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  constructor(private restangular: Restangular) {}

  getTaskById(userId: string, taskId: string): Promise<any> {
    return this.restangular.one('users', userId).one('tasks', taskId).get().toPromise();
  }
}
